import React, { Component } from 'react'

import 'react-quill/dist/quill.snow.css'
import ReactQuill, { Quill } from 'react-quill'

import QuillMention from 'quill-mention'
import QuillMarkdownShortcuts from 'vendor/markdown-shortcuts'
import AutoLinks from 'quill-auto-links'

import {
    isMobile,
    doDirtyInput
} from 'utils'

export default class QuillWysiwyg extends Component {
    lastCheckedNoteId = false
    isCollaborating = false
    codoxInstance = null
    editor = null

    constructor(props) {
        super(props)


        if (!window.registeredQuill) {
            Quill.register('modules/markdownShortcuts', QuillMarkdownShortcuts)
            Quill.register('modules/autoLinks', AutoLinks)

            window.registeredQuill = true
        }
    }

    UNSAFE_componentWillUpdate = nextProps => {
        const {
            thisUser,
            canCollaborate,
            objectId
        } = nextProps

        // On mount, the editor isn't visible.
        if (this.quillRef && objectId && this.lastCheckedNoteId !== objectId) {
            this.lastCheckedNoteId = objectId

            this.stopExistingCodox()

            const shouldAllowCodox = false // it's fucking wiping everyone's notes again.

            if (canCollaborate && window.Codox && shouldAllowCodox) {
                const config = {
                    app: "quilljs",
                    editor: this.quillRef.editor,
                    docId: 'note_' + objectId,
                    username: thisUser.first_name,
                    apiKey: "17f1e9c6-f8cf-44f7-9646-72d2783226e0"
                }

                this.codoxInstance = new window.Codox()
                this.codoxInstance.start(config)

                this.isCollaborating = true
            }

            setTimeout(_ => {
                if (this.quillRef && this.quillRef.editor) {
                    this.quillRef.editor.history.clear()
                }
            }, 100)
        }
    }

    componentWillUnmount = _ => {
        this.stopExistingCodox()

        doDirtyInput('remove', 'comment')
    }

    stopExistingCodox = _ => {
        if (this.codoxInstance) {
            this.codoxInstance.stop()
        }
    }

    mentionModule = {
        allowedChars: /^[A-Za-z\s]*$/,
        mentionDenotationChars: ["@"],
        source: (searchTerm, renderList) => {
            let values = this.props.availableMentions

            if (!searchTerm.length) {
                renderList(values, searchTerm)
            } else {
                const matches = []

                values.forEach(value => {
                    if (~value.value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
                        matches.push(value)
                    }
                })

                renderList(matches, searchTerm)
            }
        },
    }

    handleChange = newValue => {
        const {
            onChange,
            value,
            context
        } = this.props

        if (value === newValue) {
            return
        }

        if (context && context === 'comment') {
            let shouldRemove = !newValue || newValue === '<p></p>' || newValue === '<p><br></p>'

            doDirtyInput(shouldRemove ? 'remove' : 'add', 'comment')
        }

        onChange(newValue)
    }

    render() {
        const {
            value,
            isVisible,
            context,
            placeholder,
            canEdit,
            onKeyPress
        } = this.props

        if (!isVisible) {
            return null
        }

        let className = ''

        if (context == 'comment') {
            className += ' small'
        }

        if (!canEdit) {
            className += ' disabled'
        }

        return (
            <div>
                <ReactQuill
                    value={value}
                    onChange={this.handleChange}
                    ref={ref => this.quillRef = ref}
                    modules={{
                        mention: /* isMobile() ? null : */ this.mentionModule,
                        markdownShortcuts: {},
                        autoLinks: true,
                        clipboard: { matchVisual: false },
                    }}
                    className={className}
                    placeholder={placeholder ? placeholder : ''}
                    readOnly={!canEdit}
                    onKeyDown={onKeyPress}
                />
            </div>
        )
    }
}
